import type { ReactNode } from 'react';

export const symbol_tatami_seat: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M274-120q-36 0-68-16t-54-45q-23-29-29.5-65t3.5-71l25-87-28-401q-1-13 7-22t21-10l41-3q63-5 111 37t53 106l9 123q5 63-36.5 111.5T223-409l-39 109q-6 21-2 43t18 40q6 8 15 15.5t29 18.5q5-69 49.5-115.5T398-345h289q64 0 109 45t45 109v41q0 13-8.5 21.5T811-120H274Zm30-60 477-11q0-39-27.5-66.5T687-285H398q-39 0-66.5 30.5T304-180Zm-97-288q44-3 72.5-32.5T305-569l-9-123q-2-39-34.5-64.5T185-779l22 311Zm336 288ZM196-626Z"
		/>
	</svg>
);
